import React from 'react';

// Two drifting star layers over a deep-space radial gradient. Cheap, pure CSS.
// z-index sits under everything; parent should be relative + overflow-hidden.
const Starfield: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden>
    <div className="absolute inset-0 bg-deep-space" />
    <div className="absolute inset-0 bg-aurora-glow" />
    <div className="starfield absolute -inset-40 opacity-70 animate-drift" />
    <div className="starfield absolute -inset-40 opacity-40 animate-drift"
         style={{ animationDuration: '90s', backgroundSize: '500px 300px' }} />
  </div>
);

export default Starfield;
